import React from "react";
import { Button } from "../common";
import type { ButtonVariant } from "../common/Button/Button";

export interface FilterOptionProps {
	option: string;
	className: string;
	ariaPressed: boolean;
	variant: DogsTrust.ButtonVariant;
	onClick: () => void;
	disabled: boolean;
}
export const FilterOption: React.FC<FilterOptionProps> = ({
	option,
	className,
	ariaPressed,
	variant,
	onClick,
	disabled,
}) => {
	return (
		<div key={option} className={className}>
			<Button
				key={option}
				ariaPressed={ariaPressed}
				variant={variant}
				fullWidth={true}
				onClick={onClick}
				disabled={disabled}
			>
				{option}
			</Button>
		</div>
	);
};

export default FilterOption;
